import {BoundCardModal} from '@logistics-frontend/bound-card/desktop'
import React from 'react'

import {useChangeCardModal} from './hooks'
import {Props} from './types'

export function ChangeCardModal(props: Props) {
  const {card, onClose, onChange} = props
  const {fetchBindingUrl, fetchCards, fetchBoundCard} = useChangeCardModal(props)

  return (
    <BoundCardModal
      card={card}
      fetchBindingUrl={fetchBindingUrl}
      fetchBoundCard={fetchBoundCard}
      fetchCards={fetchCards}
      onClose={onClose}
      onSuccess={onChange}
    />
  )
}
